import { useCallback } from 'react'
import {
  ChatCitation,
  ChatContextSourceType,
} from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { useDocumentSourceContext } from 'src/context/DocumentSource/DocumentSourceContext'

type UseDocumentPreviewReturn = {
  openDocumentPreview: (
    contentId: string,
    name: string,
    mimeType: string,
  ) => void
}

/**
 * Hook that provides a function to open a document preview modal.
 * Used to preview documents in playbook parameters, schedules, and chat contexts.
 * The modal shows based on currentDocumentSource being set, not modal state,
 * allowing it to overlay on top of existing modals.
 */
export const useDocumentPreview = (): UseDocumentPreviewReturn => {
  const { setCurrentDocumentSource } = useDocumentSourceContext()

  const openDocumentPreview = useCallback(
    (contentId: string, name: string, mimeType: string) => {
      if (!contentId || !mimeType) return
      const citation = new ChatCitation()
      citation.setCaption(name)
      citation.setType(ChatContextSourceType.CHAT_UPLOAD_DOCUMENT)
      citation.setContentId(contentId)
      citation.setMimetype(mimeType)
      setCurrentDocumentSource(citation)
    },
    [setCurrentDocumentSource],
  )

  return { openDocumentPreview }
}
